import { createElement, FC } from 'react';
import Analysis from '@components/EntityDrawers/drawers/Risk/tabs/Analysis';
import General from '@components/EntityDrawers/drawers/Risk/tabs/General';
import { DrawerContentProps } from '@components/EntityDrawers/hocs/withDrawer';

export const RiskContent: FC<DrawerContentProps> = ({ tab }) => {
  return createElement([General, Analysis][tab ?? 0]);
};
